import React from 'react';
import { motion } from 'framer-motion';

import { Row, Col } from './Grid';
import Selection from './Selection';

import { breakpoints } from '../config';
import useMatchMedia from '../useMatchMedia';

const StackForm = ({ children, ...rest }) => {
  const isMobile = useMatchMedia(`(max-width: ${breakpoints.md})`);

  return (
    <motion.div initial="exit" animate="enter" exit="exit" style={{ display: 'flex', flex: 1 }}>
      <form noValidate {...rest}>
        {!isMobile ? (
          <Row>
            <Col>
              <motion.div
                initial={{ x: 50, opacity: 0 }}
                animate={{ x: 0, opacity: 1 }}
                exit={{ x: -50, opacity: 0 }}
                transition={{ duration: 0.25 }}
              >
                {children}
              </motion.div>
            </Col>

            <Col>
              <Selection />
            </Col>
          </Row>
        ) : (
          children
        )}

        <style jsx>{`
          form {
            display: flex;
            flex-direction: column;
            flex: 1;
            margin-bottom: 0;
          }

          @media screen and (min-width: ${breakpoints.md}) {
            form {
              padding-top: 56px;
              padding-bottom: 56px;
            }
          }

          form :global(> :first-child) {
            flex: 1;
          }
        `}</style>
      </form>
    </motion.div>
  );
};

export default StackForm;
